import { createCompanyDetailsPayloadFromCompanyDetails } from '.';
import { showErrorSnackbar } from '../../../components/snackBar/snakbar';
import { CompanyDetails, CreateCompanyDetailsInput, CreatecompanydetailsMutationVariables } from '../../../graphql';
import { CompanyPartyAddressEntity, CreateCompanyDetailsMutation, createCompanyEntityMutation } from '../api/createFinancialyear.api';
import { FinancialYearState, GstDetailsValidationErrors } from '../types';

export const handleCreateCompanyDetailsAndEntity = async (
  state: FinancialYearState,
  setButtonLoading: (val: boolean) => void,
  setGstDetailsValidationErrors: (val: GstDetailsValidationErrors) => void,
  gstDetailsValidationErrors: GstDetailsValidationErrors
): Promise<boolean> => {
  try {
    setButtonLoading(true);
    const { companyDetails, companyEntity, companyAddressEntity,emailContact,phoneContacts } = state;
    if (!companyDetails || !companyEntity) {
      showErrorSnackbar('Company details or entity info is missing.', 'right', 'bottom');
      return false;
    }

    if (String(companyDetails?.registrationtype) !== '1' && !companyEntity.gstin) {
      setGstDetailsValidationErrors({ ...gstDetailsValidationErrors, gstin: 'Gstin is Required' });
      return false;
    }

    const { statuscode, statusmessage, companydeletiontime, lastupdatedby, ...updateDetails } = companyDetails;
    updateDetails.comppercentage = updateDetails.comppercentage || 0;
    updateDetails.einvoiceconnect = updateDetails.einvoiceconnect || 0;
    updateDetails.ewaybillconnect = updateDetails.ewaybillconnect || 0;
    updateDetails.financialyearid = state.financialYearToId;

    if (companyEntity.legalname && companyEntity.financialyearcode) {
      const payload = createCompanyDetailsPayloadFromCompanyDetails(updateDetails,emailContact?.emailaddress || '',phoneContacts?.phonenumber || '');
      await Promise.all([
        CreateCompanyDetailsMutation(payload),
        ...(companyEntity.gstin
          ? [
              createCompanyEntityMutation({
                createcompanyentityInput: [
                  {
                    expiredtimestamp: companyEntity.expiredtimestamp || 0,
                    gstin: companyEntity.gstin,
                    financialyearcode: companyEntity.financialyearcode,
                    companyentitytype: companyEntity.companyentitytype || '',
                    legalname: companyEntity.legalname,
                    startdate: companyEntity.startdate || 0,
                    financialyearid: state.financialYearToId,
                  },
                ],
              }),
            ]
          : []),

        CompanyPartyAddressEntity({
          createPartyAddressEntityInput: [
            {
              city: companyAddressEntity?.city || '',
              countrycode: companyAddressEntity?.countrycode || '',
              district: companyAddressEntity?.district || '',
              expiredtimestamp: 0,
              line1: companyAddressEntity?.line1 || '',
              line2: companyAddressEntity?.line2 || '',
              line3: companyAddressEntity?.line3 || '',
              pincode: companyAddressEntity?.pincode || '',
              objectid: Number(companyAddressEntity?.objectid) || 0,
              objecttype: companyAddressEntity?.objecttype || '',
              statecode: Number(companyAddressEntity?.statecode) || 0,
              financialyearid: state.financialYearToId,
            },
          ],
        }),
      ]);
    }

    return true;
  } catch (err) {
    showErrorSnackbar('Failed to save GSTIN/company details.', 'right', 'bottom');
    return false;
  } finally {
    setButtonLoading(false);
  }
};

